import { allFeaturesAtFalse } from './default';
export const features = {
    ...allFeaturesAtFalse,
    home: {
        ...allFeaturesAtFalse.home,
        advantages: false,
    },
    contact: {
        mailTo: 'contact@countrymalt.com',
    },
    footer: {
        social: {
            facebook: 'https://www.facebook.com/countrymalt',
            linkedin: 'https://www.linkedin.com/company/the-country-malt-group',
            instagram: 'https://www.instagram.com/countrymalt',
            youtube: 'https://www.youtube.com/c/CountryMaltGroup',
        },
        sitemap: [
            {
                title: 'Customer Service',
                links: [
                    {
                        label: 'Order tracking',
                        externalHref: 'https://tracking.countrymalt.com/',
                    },
                    {
                        label: 'Contact us',
                        externalHref: 'https://www.countrymalt.com/contact-us',
                    },
                    {
                        label: 'FAQ',
                        externalHref: 'https://www.countrymalt.com/faq',
                    },
                ],
            },
            {
                title: 'About us',
                links: [
                    {
                        label: 'Blog',
                        externalHref: 'https://resources.countrymalt.com/mashing-in/',
                    },
                    {
                        label: 'Our heritage',
                        externalHref: 'https://www.countrymalt.com/heritage',
                    },
                    {
                        label: 'Careers',
                        externalHref: 'https://www.countrymalt.com/careers',
                    },
                    {
                        label: 'Locations & sales team',
                        externalHref: 'https://www.countrymalt.com/location-and-sales-team',
                    },
                ],
            },
            {
                title: 'Resources',
                links: [
                    {
                        label: 'Beyond Beer',
                        externalHref: 'https://www.countrymalt.com/beyond',
                    },
                    {
                        label: 'Breedeck Podcast',
                        externalHref: 'https://resources.countrymalt.com',
                    },
                    {
                        label: 'Community Program',
                        externalHref: 'https://www.countrymalt.com/community',
                    },
                    {
                        label: 'Filson Vest Gold Medal Program',
                        externalHref: 'https://resources.countrymalt.com/gold-medal-program/',
                    },
                    {
                        label: 'Grain to Glass Posters',
                        externalHref: 'https://www.countrymalt.com/posters',
                    },
                    {
                        label: 'Hops Ride Free',
                        externalHref: '  https://www.countrymalt.com/hops-ride-free',
                    },
                    {
                        label: 'Malt Bag Recycling Program',
                        externalHref: 'https://resources.countrymalt.com/malt-bag-recycling-program/',
                    },
                    {
                        label: 'Recipes',
                        externalHref: 'https://www.countrymalt.com/recipes',
                    },
                ],
            },
        ],
    },
    equalWeb: true,
    axeptio: {
        i18n: {
            cases: {
                default: 'cmg-US-en',
                'en-US': 'cmg-US-en',
                'en-CA': 'cmg-CA-en',
                'fr-CA': 'cmg-CA-fr',
            },
        },
    },
};
//# sourceMappingURL=countrymalt.js.map